import React, { forwardRef, useMemo } from 'react'

import PropTypes from 'prop-types'

import TransferListForm from './TransferListForm'
import TransferListStyled from './TransferListStyled'

const TransferList = forwardRef((props, ref) => {
  const {
    detached,
    value,
    ...rest
  } = props

  const Input = useMemo(
    () => detached ? TransferListStyled : TransferListForm,
    [detached]
  )

  return (
    <Input
      ref={ ref }
      value={ value }
      { ...rest }
    />
  )
})

TransferList.propTypes = {
  detached: PropTypes.bool,
  setMask: PropTypes.func,
  value: PropTypes.any
}

TransferList.defaultProps ={
  detached: false,
  setMask: undefined,
  value: ''
}

export default TransferList
